import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  idAttribute: "claimNbr",
  namedAttributes: {
    claimNbr: String,
    commercialPlanId: String,
    claimType: String,
    providerFirstName: String,
    providerLastName: String,
    providerNbr: String,
    fromDos: Date,
    throughDos: Date,
    procCode: String,
  },
  defaults: {
    claimNbr: null,
    commercialPlanId: null,
    claimType: null,
    providerFirstName: null,
    providerLastName: null,
    providerNbr: null,
    fromDos: null,
    throughDos: null,
    procCode: null,
  },
});

export { Model as default };
